import { Box, Stack } from "@mui/material";
import React from "react";
import { green, pink } from "../../shared/colours";

const PolicyPercentBar = (props) => {

	const barStyle = {
		position: "relative",
		top: "0",
		left: "0",
		backgroundColor: pink,
		height: "1em",
		borderRadius: "0.5em"
	};
	
	return (
		<Stack direction="column" sx={{ width: "8em" }}>
			<Stack direction="row" sx={{ width: "100%", margin: "auto" }}>
				<Box sx={{ width: "100%" }}>
					<Box sx={{ ...barStyle, width: "100%" }}></Box>
					<Box sx={{ ...barStyle, top: "-1em", backgroundColor: green, width: props.percent }}></Box>
				</Box>
			</Stack>
		</Stack>
	);

}

export default PolicyPercentBar;